<template>
    <input
        type="text"
        :value="number"
        :disabled="disabled"
        @keyup.tab="tabbed"
        @input="updateValue($event.target.value)" />
</template>

<script>
    /**
     * Component Dependencies
     */
    import Cleave from 'cleave.js'

    /**
     * Cleave Form Input Component
     */
    export default {
        props: {
            value: {
                default: ''
            },
            options: {
                type: Object,
                default: () => ({})
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data () {
            return {
                number: null
            }
        },
        watch: {
            value (val) {
                if (this.number !== val) {
                    this.number = val
                    this.$nextTick(() => {
                        this.cleave.setRawValue(val)
                    })
                }
            },
            disabled () {
                this.$nextTick(() => {
                    this.cleave.setRawValue(this.number)
                })
            }
        },
        methods: {
            updateValue (value) {
                this.$emit('input', parseFloat(this.cleave.getRawValue(), 2))
            },
            tabbed () {
                this.$emit('tabbed')
            }
        },
        created () {
            this.number = this.value
        },
        mounted () {
            this.cleave = new Cleave(this.$el, this.options)
        },
        beforeDestroy () {
            this.cleave.destroy()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/misc/Cleave.vue